export default "__VITE_ASSET__7074becc__"